export default {
  computed: {
    isTouchDevice () {
      return 'ontouchstart' in window || navigator.maxTouchPoints > 0
    }
  }
}
